import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const mapFieldRiskLevelFilter = (item, index) => {
  return {
    ...item,
    index,
    key: uuidv4(),
    id: item?.risk_level_id,
    name: item?.likelihood_level?.report_hd_att_val_name,
  }
}

export const getRiskLevelFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/risk_level',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldRiskLevelFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
